import { CallbackType, ErrorObjectType, validate, ValidatorRuleType } from "@tLinc/Utilities/Validate";
import React from "react";

export function useForm<TFormValues extends {}>({
    formValues,
    initialErrorState,
    validatorConfig,
}: {
    formValues: TFormValues;
    initialErrorState: { [key in keyof TFormValues]?: string };
    validatorConfig: { [key in keyof TFormValues]: ValidatorRuleType };
}) {
    type FormErrorsType = { [key in keyof TFormValues]?: string };
    const [formState, updateFormState] = React.useState<TFormValues>(formValues);
    const [formErrors, updateFormErrors] = React.useState<FormErrorsType>(initialErrorState);

    const validateSubmitDisabled = () => {
        return Object.keys(formErrors).length !== 0;
    };

    const fieldChangeHandler = ({ name, value }: { name: string; value: string }) => {
        validateField({ name, value });
        updateFormState({ ...formState, [name]: value });
    };

    const validateField = ({ name, value }: { name: string; value: string }, customValidation?: CallbackType): void => {
        const isValidate: ErrorObjectType | undefined = validate(
            {
                name,
                value,
            },
            validatorConfig[name as keyof TFormValues],
            customValidation,
        );
        const formErrs = formErrors ? { ...formErrors } : ({} as FormErrorsType);
        if (isValidate === undefined) {
            delete formErrs[name as keyof TFormValues];
        } else {
            formErrs[name as keyof TFormValues] = isValidate ? isValidate.errorMsg : isValidate;
        }
        if (!validatorConfig[name as keyof TFormValues].required && value === "") {
            delete formErrs[name as keyof TFormValues];
        }
        updateFormErrors(() => formErrs);
    };
    return {
        formState,
        formErrors,
        isSubmitDisabled: validateSubmitDisabled(),
        updateFormState,
        updateFormErrors,
        validateField,
        fieldChangeHandler,
    };
}
